import { StringHelper } from '../../../core/helpers/strings.helper';
import { FormControl, FormGroup, FormArray } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-base-form',
	templateUrl: './base-form.component.html',
	styleUrls: ['./base-form.component.scss']
})
export class BaseFormComponent implements OnInit {
	submittingForm: boolean;
	errorMessage: any;
	form: FormGroup;

	constructor(
		public formBuilder: FormBuilder,
	) {
		this.form = new FormGroup({});
	}

	ngOnInit(): void {
	}

	public validateForm(): boolean {
		this.errorMessage = null;
		if (!this.form.valid) {
			this.validateAllFields(this.form);
		}
		return this.form.valid;
	}

	validateAllFields(formGroup: FormGroup) {
		Object.keys(formGroup.controls).forEach(field => {
			const control = formGroup.get(field);
			if (control instanceof FormControl) {
				control.markAsTouched({ onlySelf: true });
				control.markAsDirty();
				control.updateValueAndValidity();
			} else if (control instanceof FormGroup) {
				this.validateAllFields(control);
			} else if (control instanceof FormArray) {
				for (const item of control.controls) {
					this.validateAllFields(item as FormGroup);
				}
			}
		});
	}

	onError(error) {
		this.submittingForm = false;
		this.errorMessage = StringHelper.getErrorMessage(error);
	}

}
